import type { MatchData } from "./types";

// ==================================================

// MEN'S DOMESTIC MATCHES 2026/27

// GALLAGHER PREM

// ==================================================

export const matches2026PremMen: MatchData[] = [

  // ==================================================

  // GALLAGHER PREM 2026/27 — ROUND 1

  // ==================================================

  {
    id: 9001,

    matchKey: "northampton-saints-vs-newcastle-red-bulls",

    competitionId: "premiership",

    tournamentInstanceId: "premiership-2027",

    tournament: "Gallagher Premiership 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-25",

    venue: "Franklin's Gardens, Northampton",

    home: {
      name: "Northampton Saints",
      country: "prem-northampton-saints",
    },

    away: {
      name: "Newcastle Red Bulls",
      country: "prem-newcastle-red-bulls",
    },

    score: {
      home: 59,
      away: 26,
    },

    state: "final",

    startTime: "19:45",
  },

  {
    id: 9002,

    matchKey: "harlequins-vs-bath",

    competitionId: "premiership",

    tournamentInstanceId: "premiership-2027",

    tournament: "Gallagher Premiership 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-25",

    venue: "Twickenham Stoop, London",

    home: {
      name: "Harlequins",
      country: "prem-harlequins",
    },

    away: {
      name: "Bath",
      country: "prem-bath",
    },

    score: {
      home: 17,
      away: 33,
    },

    state: "final",

    startTime: "19:45",
  },

  // ==================================================

  // GALLAGHER PREM 2026/27 — ROUND 1 (SAT/SUN)

  // ==================================================

  {
    id: 9003,

    matchKey: "exeter-chiefs-vs-gloucester",

    competitionId: "premiership",

    tournamentInstanceId: "premiership-2027",

    tournament: "Gallagher Premiership 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-26",

    venue: "Sandy Park, Exeter",

    home: {
      name: "Exeter Chiefs",
      country: "prem-exeter-chiefs",
    },

    away: {
      name: "Gloucester",
      country: "prem-gloucester",
    },

    score: { home: 24, away: 45 },
    state: "final",

    startTime: "15:05",
  },

  {
    id: 9004,

    matchKey: "sale-sharks-vs-bristol-bears",

    competitionId: "premiership",

    tournamentInstanceId: "premiership-2027",

    tournament: "Gallagher Premiership 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-26",

    venue: "CorpAcq Stadium, Salford",

    home: {
      name: "Sale Sharks",
      country: "prem-sale-sharks",
    },

    away: {
      name: "Bristol Bears",
      country: "prem-bristol-bears",
    },

    score: { home: 24, away: 34 },
    state: "final",

    startTime: "17:30",
  },

  {
    id: 9005,

    matchKey: "leicester-tigers-vs-saracens",

    competitionId: "premiership",

    tournamentInstanceId: "premiership-2027",

    tournament: "Gallagher Premiership 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-27",

    venue: "Mattioli Woods Welford Road, Leicester",

    home: {
      name: "Leicester Tigers",
      country: "prem-leicester-tigers",
    },

    away: {
      name: "Saracens",
      country: "prem-saracens",
    },

    score: { home: 38, away: 40 },
    state: "final",

    startTime: "15:00",
  },

// ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 2
// ==================================================
{
  id: 9006,
  matchKey: "bath-vs-exeter-premiership",
  competitionId: "premiership",
   tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-02",
  venue: "Recreation Ground, Bath",
  home: { name: "Bath", country: "england" },
  away: { name: "Exeter Chiefs", country: "england" },
  score: { home: 40, away: 34 },
    state: "final",
  startTime: "20:45",
},

{
  id: 9007,
  matchKey: "bristol-vs-northampton-premiership",
  competitionId: "premiership",
   tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Ashton Gate, Bristol",
  home: { name: "Bristol Bears", country: "england" },
  away: { name: "Northampton Saints", country: "england" },
 score: { home: 41, away: 26 },
    state: "final",
  startTime: "15:05",
},

{
  id: 9008,
  matchKey: "gloucester-vs-harlequins-premiership",
  competitionId: "premiership",
   tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Kingsholm, Gloucester",
  home: { name: "Gloucester", country: "england" },
  away: { name: "Harlequins", country: "england" },
  score: { home: 48, away: 0 },
    state: "final",
  startTime: "17:30",
},

{
  id: 9009,
  matchKey: "newcastle-vs-leicester-premiership",
  competitionId: "premiership",
   tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Kingston Park, Newcastle",
  home: { name: "Newcastle", country: "england" },
  away: { name: "Leicester Tigers", country: "england" },
  score: { home: 19, away: 24 },
    state: "final",
  startTime: "19:45",
},

{
  id: 9010,
  matchKey: "saracens-vs-sale-premiership",
  competitionId: "premiership",
   tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-04",
  venue: "StoneX Stadium, London",
  home: { name: "Saracens", country: "england" },
  away: { name: "Sale Sharks", country: "england" },
  score: { home: 17, away: 21 },
    state: "final",
  startTime: "15:00",
},

// ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 3
// ==================================================

{
  id: 9011,
  matchKey: "leicester-vs-gloucester-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-09",
  venue: "Mattioli Woods Welford Road, Leicester",
  home: { name: "Leicester Tigers", country: "england" },
  away: { name: "Gloucester", country: "england" },
  score: { home: 27, away: 27 },
  state: "final",
  startTime: "20:45",
},
{
  id: 9012,
  matchKey: "northampton-vs-bath-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "Franklin’s Gardens, Northampton",
  home: { name: "Northampton Saints", country: "england" },
  away: { name: "Bath", country: "england" },
  score: { home: 33, away: 31 },
  state: "final",
  startTime: "16:05",
},
{
  id: 9013,
  matchKey: "saracens-vs-bristol-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "StoneX Stadium, London",
  home: { name: "Saracens", country: "england" },
  away: { name: "Bristol Bears", country: "england" },
  score: { home: 32, away: 24 },
  state: "final",
  startTime: "18:30",
},
{
  id: 9014,
  matchKey: "sale-vs-harlequins-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-11",
  venue: "CorpAcq Stadium, Salford",
  home: { name: "Sale Sharks", country: "england" },
  away: { name: "Harlequins", country: "england" },
  score: { home: 28, away: 25 },
  state: "final",
  startTime: "16:00",
},
{
  id: 9015,
  matchKey: "exeter-vs-newcastle-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-11",
  venue: "Sandy Park, Exeter",
  home: { name: "Exeter Chiefs", country: "england" },
  away: { name: "Newcastle", country: "england" },
  score: { home: 36, away: 12 },
  state: "final",
  startTime: "16:00",
},

// ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 4
// ==================================================

{
  id: 9016,
  matchKey: "gloucester-vs-bath-premiership",
 competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-23",
  venue: "Kingsholm, Gloucester",
  home: { name: "Gloucester", country: "england" },
  away: { name: "Bath", country: "england" },
  score: { home: 23, away: 5 },
  state: "final",
  startTime: "19:45",
},

{
  id: 9017,
  matchKey: "newcastle-vs-sale-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-23",
  venue: "Kingston Park, Newcastle",
  home: { name: "Newcastle Red Bulls", country: "england" },
  away: { name: "Sale Sharks", country: "england" },
  score: { home: 17, away: 3 },
  state: "final",
  startTime: "19:45",
},

{
  id: 9018,
  matchKey: "leicester-vs-northampton-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-24",
  venue: "Mattioli Woods Welford Road, Leicester",
  home: { name: "Leicester Tigers", country: "england" },
  away: { name: "Northampton Saints", country: "england" },
 score: { home: 28, away: 7 },
  state: "final",
  startTime: "15:05",
},

{
  id: 9019,
  matchKey: "bristol-vs-exeter-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-24",
  venue: "Ashton Gate, Bristol",
  home: { name: "Bristol Bears", country: "england" },
  away: { name: "Exeter Chiefs", country: "england" },
  score: { home: 20, away: 7 },
  state: "final",
  startTime: "17:30",
},

{
  id: 9020,
  matchKey: "harlequins-vs-saracens-premiership",
 competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-25",
  venue: "Twickenham Stoop, London",
  home: { name: "Harlequins", country: "england" },
  away: { name: "Saracens", country: "england" },
  score: { home: 33, away: 15 },
  state: "final",
  startTime: "15:00",
},

// ==================================================
// GALLAGHER PREMIERSHIP 2026/27 – ROUND 5
// ==================================================

{
  id: 9021,
  matchKey: "bristol-vs-leicester-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-30",
  venue: "Ashton Gate, Bristol",
  home: { name: "Bristol Bears", country: "prem-bristol" },
  away: { name: "Leicester Tigers", country: "prem-leicester" },
  state: "upcoming",
  startTime: "19:45",
},

{
  id: 9022,
  matchKey: "exeter-vs-harlequins-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Sandy Park, Exeter",
  home: { name: "Exeter Chiefs", country: "prem-exeter" },
  away: { name: "Harlequins", country: "prem-harlequins" },
  state: "upcoming",
  startTime: "15:00",
},

{
  id: 9023,
  matchKey: "saracens-vs-newcastle-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "StoneX Stadium, London",
  home: { name: "Saracens", country: "prem-saracens" },
  away: { name: "Newcastle", country: "prem-newcastle" },
  state: "upcoming",
  startTime: "15:00",
},

{
  id: 9024,
  matchKey: "bath-vs-sale-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Recreation Ground, Bath",
  home: { name: "Bath", country: "prem-bath" },
  away: { name: "Sale Sharks", country: "prem-sale" },
  state: "upcoming",
  startTime: "15:05",
},

{
  id: 9025,
  matchKey: "northampton-vs-gloucester-premiership",
  competitionId: "premiership",
  tournamentInstanceId: "premiership-2027",
  tournament: "Gallagher Premiership 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Franklin's Gardens, Northampton",
  home: { name: "Northampton Saints", country: "prem-northampton" },
  away: { name: "Gloucester", country: "prem-gloucester" },
  state: "upcoming",
  startTime: "17:30",
},



];